module.exports = __webpack_public_path__ + "img/image (18).d9ebb2e4.png";